import React, { useContext, useEffect, useState } from "react";
import { Col, Input, Row } from "reactstrap";
import _ from "lodash";
import { ItemTypeahead, SpinnerButton } from "./";
import { api, constants, UserContext } from "../utils";
import { DesktopContainer } from "../layouts";
import { toast } from "react-toastify";
import Select from "react-select";
import Switch from "react-switch";
import NumericFormat from "react-number-format";

export default function PrintConeLabels() {
   const { currentUser } = useContext(UserContext);
   const INIT_DATA = {
      Item: "",
      LabelCount: 1,
      OtherInfo: "",
      printerId: 0,
      printerName: "NONE",
      printPdf: false
   };
   const [data, setData] = useState(INIT_DATA);
   const [downloading, setDownloading] = useState(false);
   const [initialized, setInitialized] = useState(false);
   const [itemNumber, setItemNumber] = useState("");
   const [otherInfo, setOtherInfo] = useState("");
   const [printers, setPrinters] = useState([]);
   const [printPdf, setPrintPDF] = useState(false);
   const [showPdfPrint, setShowPrint] = useState(false);
   const [spec, setSpec] = useState(null);
   const [qty, setQty] = useState(1);
   const [selectedPrinter, setSelectedPrinter] = useState(null);
   const refresh = () => window.location.reload(true)

   useEffect(() => {
      async function setDropdowns() {
         if (!currentUser) return;
         api
            .fetch(`Production/LoadConeLabelPrinters`)
            .then(response => {
               if (response.data.success) {
                  setShowPrint(response.data.showPdfPrint);
                  const printerList = _.map(response.data.printers, p => ({ value: p.id, label: p.nameOnly }));
                  return { printerList: printerList };
               } else {
                  throw new Error(response);
               }
            })
            .then(async ({ printerList }) => {
               setPrinters(printerList);
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => setInitialized(true))
      }
      setDropdowns();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentUser])

   useEffect(() => {
      if (!itemNumber) {
         setSpec(null);
         setOtherInfo("");
         return;
      }
      getSpecificationByItem();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [itemNumber]);

   useEffect(() => {
      let changes = Object.assign({}, data);
      if (selectedPrinter) {
         changes.printerId = selectedPrinter.value;
         changes.printerName = selectedPrinter.label;
      }
      else {
         changes.printerId = 0;
         changes.printerName = "NONE";
      }
      changes.printPdf = printPdf;
      setData(changes);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [selectedPrinter, printPdf])

   function handleCountChange(num) {
      if (!num || num < 1) {
         num = 1;
      }
      let changes = Object.assign({}, data);
      changes.LabelCount = num;
      setData(changes);
      setQty(num);
   }

   function handleItemNumberChange(number) {
      if (!number) {
         let changes = Object.assign({}, INIT_DATA);
         setData(changes); // null?
         setItemNumber(null);
      } else {
         let changes = Object.assign({}, data);
         changes.Item = number.itemNumber;
         setData(changes);
         setItemNumber(number);
      }
   }

   const handlePrint = nextChecked => { setPrintPDF(nextChecked); }

   function getSpecificationByItem() {
      api
         .post("Quality/GetSpecificationByItemNumber", { itemNumber: itemNumber.itemNumber })
         .then((response) => {
            if (response && response.data.success && response.data.item) {
               setSpec(response.data.item);
               setOtherInfo(response.data.item.labelLine3);
            } else if (response && response.data.success && !response.data.item) {
               toast.error("No specification for this item number.");
            } else {
               toast.error("There was an error fetching the specification.")
            }
         })
         .catch(api.catchHandler);
   }

   function printLabel() {
      let payload = Object.assign({}, data);
      //payload.Item = itemNumber?.itemNumber;
      payload.OtherInfo = otherInfo;

      if (!payload.Item || payload.Item === "") {
         toast.error("You must select an item number");
         return;
      }
      if (payload.LabelCount < 1) {
         toast.error("You must provide the required number of labels");
         return;
      }
      if (!payload.printPdf && payload.printerId === 0) {
         toast.error("You must select a printer");
         return;
      }

      setDownloading(true);
      if (payload.printPdf) {
         api
            .postDownloadBinary(`Report/PrintConeLabelRpt`, payload, constants.MIME_TYPES.pdf, `ConeQRLabels.pdf`)
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
               else {
                  refresh();
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => {
               setDownloading(false);
            })
      }
      else {
         api
            .post(`Report/PrintConeLabelRpt`, payload)
            .then(response => {
               if (response.data.success) {
                  toast.success("Cone QR labels were printed");
                  refresh();
               }
               else {
                  toast.error(response.data.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => {
               setDownloading(false);
            })
      }
   }

   return (
      <div>
         <DesktopContainer screenName={"Print Cone Labels"}>
            {initialized === true ? (
               <Row className="mt-3 d-flex justify-content-center align-items-center filter-header">
                  <Col xs="6">
                     <Row className="mt-3 d-flex align-items-center">
                        <Col xs="3" className="d-flex justify-content-end">
                           <p className="m-0" style={{ color: "white", fontSize: "1.25rem" }}>Item:</p>
                        </Col>
                        <Col xs="7">
                           <ItemTypeahead
                              value={itemNumber}
                              onChange={(e) => handleItemNumberChange(e)}
                              includeSampleItems
                           />
                        </Col>
                     </Row>
                  </Col>
                  <Row className="mt-3 d-flex justify-content-center align-items-center">
                     <Col xs="6">
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="mt-3" style={{ fontWeight: "bold", color: "white" }}>Label Line 1</p>
                           </Col>
                           <Col xs="7">
                              <Input
                                 type="text"
                                 value={spec?.labelLine1 || ""}
                                 disabled={true}
                              />
                           </Col>
                           <Col xs="2">
                              <p className="mt-3" style={{ fontWeight: "bold", color: "white" }}>Part Number</p>
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="mt-3" style={{ fontWeight: "bold", color: "white" }}>Label Line 2</p>
                           </Col>
                           <Col xs="7">
                              <Input
                                 type="text"
                                 value={spec?.labelLine2 || ""}
                                 disabled={true}
                              />
                           </Col>
                           <Col xs="2">
                              <p className="mt-3" style={{ fontWeight: "bold", color: "white" }}> Item Description</p>
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="mt-3" style={{ fontWeight: "bold", color: "white" }}>Label Line 3</p>
                           </Col>
                           <Col xs="7">
                              <Input
                                 type="text"
                                 value={otherInfo || ""}
                                 onChange={(e) => setOtherInfo(e.target.value)}
                              />
                           </Col>
                           <Col xs="2">
                              <p className="mt-3" style={{ fontWeight: "bold", color: "white" }}>Other Information</p>
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="mt-3" style={{ fontWeight: "bold", color: "white" }}>Label Line 4</p>
                           </Col>
                           <Col xs="7">
                              <Input
                                 type="text"
                                 value={spec?.labelLine4 || ""}
                                 disabled={true}
                              />
                           </Col>
                           <Col xs="2">
                              <p className="mt-3" style={{ fontWeight: "bold", color: "white" }}>Vendor Name</p>
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="mt-3" style={{ fontSize: "1.25rem", color: "white" }}># of Labels:</p>
                           </Col>
                           <Col xs="7">
                              <NumericFormat
                                 className="form-control"
                                 value={qty}
                                 //valueIsNumericString=true,
                                 thousandSeparator=","
                                 decimalScale={0}
                                 allowNegative={false}
                                 onValueChange={({ floatValue }) => { handleCountChange(floatValue); }}
                              />
                           </Col>
                           <Col xs="2"></Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="mt-3" style={{ fontSize: "1.25rem", color: "white" }}>Printer:</p>
                           </Col>
                           <Col xs="7">
                              <Select
                                 classNamePrefix="serviceThreadSelect"
                                 options={printers}
                                 value={selectedPrinter}
                                 onChange={(e) => setSelectedPrinter(e)}
                                 isClearable={true}
                              />
                           </Col>
                           <Col xs="2"></Col>
                        </Row>
                        {showPdfPrint === true ? (
                           <Row className="align-items-center my-1">
                              <Col className="text-end text-white h5" xs={3}>{printPdf ? "Download as PDF" : "Print to printer"}</Col>
                              <Col xs={4}>
                                 <Switch onChange={handlePrint} checked={printPdf} className="react-switch" />
                              </Col>
                              <Col xs={3}>
                                 <SpinnerButton className="shredButton float-end" onClick={printLabel} on={downloading} disabled={downloading}>
                                    Print Labels
                                 </SpinnerButton>
                              </Col>
                              <Col xs="2"></Col>
                           </Row>
                        ) :
                           <Row className="align-items-center my-1">
                              <Col xs={3}></Col>
                              <Col xs={7}>
                                 <SpinnerButton className="shredButton float-end" onClick={printLabel} on={downloading} disabled={downloading}>
                                    Print Labels
                                 </SpinnerButton>
                              </Col>
                              <Col xs={2}></Col>
                           </Row>
                        }
                     </Col>
                  </Row>
               </Row>
            ) : null}
         </DesktopContainer>
      </div>
   );
}